import { getJobsBoardLayout } from '@layouts/JobsBoardLayout';
import { PublicApplicationView } from '@views/publicApplicationView';

const PublicApplicationPage = () => <PublicApplicationView />;

PublicApplicationPage.isPublic = true;
PublicApplicationPage.getLayout = getJobsBoardLayout;

export default PublicApplicationPage;
